// ----------------------------------------------------------------------

import { IListParams } from 'utils/common';

// ----------------------------------------------------------------------

export type UserManager = {
  id: string;
  avatarUrl: string;
  name: string;
  email: string;
  phoneNumber: string;
  address: string;
  country: string;
  state: string;
  city: string;
  zipCode: string;
  company: string;
  isVerified: boolean;
  status: string;
  role: string;
};

export enum UserRole {
  SUPER_ADMIN = 'Super Admin',
  OWNER = 'Owner',
  CLIENT_ADMIN = 'Client Admin',
  SITE_ATTENDANT = 'Site Attendant',
  SITE_ENERGY_ADMIN = 'Site Energy Admin'
}

export enum UserRoleCode {
  SUPER_ADMIN = 'SPA',
  OWNER = 'OWN',
  CLIENT_ADMIN = 'CLA',
  SITE_ATTENDANT = 'SAT',
  SITE_ENERGY_ADMIN = 'SEA'
}

export type User = {
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  roles: string[];
  userStatusId?: number;
  userRoleId?: number;
  blocked?: boolean;
  boostGroupIds?: [{ boostGroupId: number; boostGroupName: string }];
  subBoostGroupIds?: number[];
  Owner?: {
    ownerId: number;
    userId?: number;
    ownerName: string;
    status?: string;
  };
  createdAt?: string;
  ownerRfidEnabled?: boolean;
};

export interface IUserListItem {
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  userStatus: string;
  blocked: boolean;
  roles: string[];
  ownerName: string;
}

export type IUser = {
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  userStatus?: string;
  userRoleId: number;
  blocked?: boolean;
  roles: string[];
  boostGroupIds?: number[];
  boostGroupIdsToRemove?: number[];
  subBoostGroupIds?: number[];
  subBoostGroupIdsToRemove?: number[];
  ownerIds?: number[];
  ownerName?: string;
  createdAt?: string;
};

export interface IUserRoles {
  roleId: number;
  roleCode: string;
  roleName: string;
}

export interface IUserListParams extends IListParams {
  ownerId?: number;
  boostGroupId?: number;
  subBoostGroupId?: number;
  roleCode?: string;
}
